import { UserWithDetails } from "./user.types";

export enum UserLogAction {
    CREATION = "creation",
    ACTIVATION = "activation",
    DEACTIVATION = "deactivation",
    REACTIVATION = "reactivation",
    DELETION = "deletion",
  }
  
  export interface UserLog {
    id: number;
    user_id: number;
    performed_by?: number;
    action: UserLogAction;
    reason: string;
    created_at: Date;
  }
  
  export interface UserLogWithDetail {
    // log
    id: number;
    action: UserLogAction;
    reason: string;
    created_at: Date;
    // users
    user: UserWithDetails;
    performed_by?: UserWithDetails;
  }
  